<input type="file" class="noDisplay" #fileInput (change)="onChangeFileInput($event)">
<button mat-icon-button class="file-select-button" matTooltip="Upload image" matTooltipPosition="above"
        (click)="onClickFileInputButton()">
  <mat-icon>image</mat-icon>
</button>
<img *ngFor="let url of urls" [src]="url" class="width-100" />
